import { Component, OnInit, Sanitizer } from '@angular/core';
import { Router } from '@angular/router';
import { SelectItem } from 'primeng/api';
import { takeWhile } from 'rxjs/operators';
import { NoticiaModel } from 'src/app/core/models/noticia.model';
import { NoticiaService } from 'src/app/core/services/noticia.service';
import { environment } from 'src/environments/environment';
import { BaseComponent } from '../../area-privada/components/base/base.component';

@Component({
  selector: 'dum-noticias',
  templateUrl: './noticias.component.html',
  styleUrls: ['./noticias.component.scss']
})
export class NoticiasComponent extends BaseComponent implements OnInit {

  noticias: NoticiaModel[] = [];
  sortOptions: SelectItem[];
  sortOrder: number;
  sortField: string;
  urlImageUpload: ArrayBuffer;
  vectorImagenes: ArrayBuffer[] = [];
  imgDefault: string = environment.img_default_news;
  constructor(
    private noticiasService: NoticiaService,
    private router: Router,
  ) {
    super();
    this.noticiasService.getAll()
    .pipe(takeWhile(() => this.alive),
  ).subscribe((noticias) => {
    this.noticias = noticias;
    this.noticias.forEach((noticia) => {
      this.getImage(noticia.id).then((res) => this.vectorImagenes[noticia.id] = res);
    });
  });
}

  ngOnInit(): void {

  }

  getUrlImg(file) {
    const reader = new FileReader();
    reader.onloadend = () => {
      this.urlImageUpload = reader.result as ArrayBuffer;
    };
    reader.readAsDataURL(file);
  }

  getImage(id: number): Promise<ArrayBuffer> {
    return new Promise((resolved, reject) => {
      this.noticiasService.getImage(id)
        .pipe(takeWhile(() => this.alive))
        .subscribe((imagen) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            resolved(reader.result as ArrayBuffer);
          };
          reader.readAsDataURL(imagen);
        });
    });
  }

  onSortChange(event) {
    const value = event.value;

    if (value.indexOf('!') === 0) {
      this.sortOrder = -1;
      this.sortField = value.substring(1, value.length);
    }
    else {
      this.sortOrder = 1;
      this.sortField = value;
    }
  }


  verNoticia(id: number) {
    this.router.navigate([`mostrar-noticia/${id}`]);
  }

}
